import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import Navbar from './Partial/Navbar';

export default function MatchOtp() {
    let navigate = useNavigate();
    let [otp, setOtp] = useState("")
    let [show, setShow] = useState(false)
    let [message, setMessage] = useState("")

    function getInputData(e) {
        setOtp(e.target.value)
    }

    async function postData(e) {
        e.preventDefault();
        let response = await fetch("/api/user/match-otp", {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify({ username: localStorage.getItem("password-reset-user"), otp: otp }),
        });

        response = await response.json();

        if (response.result === "Done") {
            toast.success("OTP has been matched successfully!", {
                position: "top-right",
                autoClose: 3000,
            });
            navigate("/reset-password")

        } else {
            setShow(true);
            setMessage(response.reason);
        }
    }

    return (
        <>
            <Navbar />
            <div className="d-flex justify-content-center align-items-center background">
                <div className="card card-respon p-2 login-box mt-5">
                    <div className="card-body" >
                        <h2 className='text-center text-dark'><span className='text-info'>Mini</span>Store</h2>
                        <h6 className="card-title text-center border-bottom border-2 p-2">Forgot Password</h6>
                        <form onSubmit={postData}>
                            <div className="row">
                                <div className="mt-3">
                                    <label className='text-info'>OTP</label>
                                    <input type="text" name="otp" onChange={getInputData} className={`form-control border-2 ${show && message ? "border-danger" : "border-dark"} w-100`} placeholder='Enter OTP' />
                                    {show && message ? <p className='text-danger'>{message}</p> : ""}
                                </div>
                            </div>
                            <div>
                                <button type="submit" className='btn btn-info border-2 w-100 mt-4'>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
